import { render, staticRenderFns } from "./rulerGroup.vue?vue&type=template&id=83f12f04&scoped=true"
import script from "./rulerGroup.vue?vue&type=script&lang=js"
export * from "./rulerGroup.vue?vue&type=script&lang=js"
import style0 from "./rulerGroup.vue?vue&type=style&index=0&id=83f12f04&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "83f12f04",
  null
  
)

export default component.exports